import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import { fadeInOut } from "src/app/common/animations/animations";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-score",
  templateUrl: "./score.component.html",
  styleUrls: ["./score.component.scss"],
  animations: [fadeInOut],
})
export class ScoreComponent implements OnInit {
  @Output() onRoute = new EventEmitter<void>();

  gamePoints: number = 0;
  gameMovements: number = 0;

  constructor() {}

  ngOnInit(): void {
    const userPoints = localStorage.getItem(
      "user-points" + environment.storage
    );

    if (userPoints && typeof +userPoints === "number") {
      this.gamePoints = +userPoints;
    }

    const userMovements = localStorage.getItem(
      "user-movements" + environment.storage
    );

    if (userMovements && typeof +userMovements === "number") {
      this.gameMovements = +userMovements;
    }
  }

  clearSession() {
    localStorage.clear();
    this.changeRoute();
  }

  changeRoute() {
    this.onRoute.emit();
  }
}
